<template>
  <div>
    <div
      :class="{ 'bg-blue-grey-lighten-5': isExpanded }"
      class="d-flex align-center justify-space-between ga-3"
      style="cursor: pointer"
      :style="{ backgroundColor: isExpanded ? '#fafbfc !important' : '' }"
      @click="setExpanded(!isExpanded)">
      <slot v-if="$slots.label" name="label"></slot>
      <span v-else class="info-block__label">{{ label }}</span>
      <slot name="action" :isExpanded="isExpanded">
        <v-btn-group density="compact" divided rounded="lg" variant="outlined">
          <v-btn size="x-small">
            <v-icon
              :icon="
                isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
              "></v-icon>
          </v-btn>
        </v-btn-group>
      </slot>
    </div>
    <div v-show="isExpanded" class="mt-2">
      <slot name="default" :isExpanded="isExpanded"></slot>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  props: {
    label: { type: String, default: '' },
    expanded: { type: Boolean, default: false },
  },
  setup(props) {
    const isExpanded = ref(props.expanded)
    const setExpanded = val => {
      isExpanded.value = val
    }

    return {
      isExpanded,
      setExpanded,
    }
  },
}
</script>
